import { TIIndicatorPointToHighChartIndicatorPointMapper } from "../mappers/data-point/ti-indicator-point-to-highchart-indicator-point.mapper";
import { TIIndicatorDataModel } from "../models/data-point/ti-indicator-data.model";
import { IndicatorOptionModel } from "../models/drop-down-list/indicator-option.model";

export class TIIndicatorDataToBBandsSeriesBuilder {
    public static map(indicator: IndicatorOptionModel, rawIndicatorData: TIIndicatorDataModel, indicatorConfig: any, useLastPrice: boolean, yAxis: string): Array<any> {
        if (!indicatorConfig || !indicatorConfig.series) {
            return [];
        }
        
        let result: Array<any> = [];

        const bbandTopSerie: any = indicatorConfig.series[0];
        const bbandBottomSerie: any = indicatorConfig.series[1];
        
        const bbandTopNeedZone = rawIndicatorData.needHighChartZone(bbandTopSerie.type);
        const builtBBandTopSerieDataPoints = TIIndicatorPointToHighChartIndicatorPointMapper.map(rawIndicatorData, indicator.value, bbandTopNeedZone);
        bbandTopSerie.name = rawIndicatorData.name;
        bbandTopSerie.data = builtBBandTopSerieDataPoints.points;
        bbandTopSerie.className = 'indicator-series ' + rawIndicatorData.getClassName();

        if (bbandTopNeedZone) {
            bbandTopSerie.zones = builtBBandTopSerieDataPoints.zones;
            rawIndicatorData.zones = builtBBandTopSerieDataPoints.zones;
            bbandTopSerie.zoneAxis = 'x';
        }
        
        bbandTopSerie.yAxis = yAxis;
        
        bbandTopSerie.lastPrice = {
            enabled: useLastPrice,
            className: 'last-price-indicator-' +  + indicator.getClassName()
        };

        result.push(bbandTopSerie);

        if (rawIndicatorData.childIndicators?.length > 0) {
            const bBandBottoms = rawIndicatorData.childIndicators.find((x: TIIndicatorDataModel) => x.name.indexOf('BB_B') >= 0);
            if (bBandBottoms) {
                const bbandBottomNeedZone = bBandBottoms.needHighChartZone(bbandBottomSerie.type);
                const builtDcBottomsDataPoints = TIIndicatorPointToHighChartIndicatorPointMapper.map(bBandBottoms, indicator.value, bbandBottomNeedZone);
                bbandBottomSerie.name = bBandBottoms.name;
                bbandBottomSerie.data = builtDcBottomsDataPoints.points;
                bbandBottomSerie.className = 'indicator-series ' + bBandBottoms.getClassName();
                
                if (bbandBottomNeedZone) {
                    bbandBottomSerie.zones = builtDcBottomsDataPoints.zones;
                    bBandBottoms.zones = builtDcBottomsDataPoints.zones;
                    bbandBottomSerie.zoneAxis = 'x';
                }

                bbandBottomSerie.yAxis = yAxis;
                
                result.push(bbandBottomSerie);
            }
        }

        return result;
    }
}
